export class CoDocumentoPk {
    companiasocio: string;
    tipodocumento: string;
    numerodocumento: string;
}
export class CoDocumento {

    pk: CoDocumentoPk;

    constructor() {
        this.pk = new CoDocumentoPk();
        this.coDocumentodetalle = [];
        this.coDocumentodetallecomentario = [];
        this.coDocumentodescuentos = [];
        this.coDocumentoimpuesto = [];
        this.syDocumentoanexos = [];
    }

    fechadocumento: Date;
    fechavencimiento: Date;
    fechapreparacion: Date;
    fechaaprobacion: Date;
    comercialpedidofecharequerida: Date;
    letrafecharecepcion: Date;
    cobranzadudosafecha: Date;
    cobranzadudosafechaclearing: Date;
    apfechatransferencia: Date;
    procesoimportacionfecha: Date;
    rutadespachofechaasignacion: Date;
    fechaimpresion: Date;
    ultimafechamodif: Date;
    fechavencimientooriginal: Date;
    letraprotestofecha: Date;
    fecharecepcion: Date;

    clientedireccionsecuencia: number;
    vendedor: number;
    tipodecambio: number;
    montoafecto: number;
    montonoafecto: number;
    montoimpuestoventas: number;
    montoimpuestos: number;
    montodescuentos: number;
    montoredondeo: number;
    montototal: number;
    montopagado: number;
    montoadelantosaldo: number;
    aprobadopordescuento: number;
    letradescuentointereses: number;
    comentariosmonto: number;
    approcesosecuencia: number;
    preciounitariogratuito: number;
    transferenciagratuitaigvfactor: number;
    pagoantes: number;
    letradescuentoportes: number;
    letracomisiones: number;
    letraintereses: number;
    letraportes: number;
    letraprotesto: number;
    montopercepcion: number;
    porcentajepercepcion: number;
    mtopendienteafecto: number;
    letramontorenovar: number;
    letrainteresesganados: number;
    gastosprotesto: number;
    fecomunicadonumero: number;
    idtipodecisionanalisis: number;
    indicadorarchivamiento: number;
    numeroenvio: number;
    clientedirecciondespachosec: number;
    autorizacionempleado: number;
    autorizacionpassword: number;
    letrapersona: number;
    approcesonumero: number;
    preparadopor: number;
    aprobadopor: number;
    clientecobrara: number;
    clientenumero: number;
    operacioncanjenumero: number;
    estComunicadobaja: number;
    feenviobaja: number;
    feinternalnumber: number;
    feresumennumero: number;
    cobrador: number;
    newopecjenro: number;

    notacreditodocumento: string;
    comercialpedidonumero: string;
    almacencodigo: string;
    impresionpendienteflag: string;
    documentomoraflag: string;
    contabilizacionpendienteflag: string;
    voucherperiodo: string;
    voucherno: string;
    voucheranulacion: string;
    centrocosto: string;
    centrocostodestino: string;
    proyecto: string;
    camporeferencia: string;
    sucursal: string;
    tipocanjefactura: string;
    letracarteraflag: string;
    letrabanco: string;
    letracobranzanumero: string;
    letraavalnombre: string;
    letraavalruc: string;
    letraavaldireccion: string;
    letraavaltelefono: string;
    letraaceptadoflag: string;
    letraaceptadopor: string;
    letraubicacion: string;
    letradescuentocuentabancaria: string;
    letradescuentovoucherflag: string;
    letradescuentovoucher: string;
    letradescuentocanjeflag: string;
    letradescuentocanjevoucher: string;
    letraprotestoflag: string;
    descuentoflag: string;
    aptransferidoflag: string;
    cobranzadudosamotivo: string;
    unidadnegocio: string;
    unidadreplicacion: string;
    procesoimportacion: string;
    cobranzadudosaestado: string;
    cobranzadudosavoucher: string;
    cobranzadudosavoucherclearing: string;
    procesoimportacionnumero: string;
    comentarios: string;
    comentariosimprimirflag: string;
    numerointerno: string;
    rutadespacho: string;
    transportistachofer: string;
    transportistavehiculo: string;
    rutadespachoplacavehiculo: string;
    transferenciagratuitaflag: string;
    letraprotestondflag: string;
    diferidodocumento: string;
    anulacionmotivo: string;
    anulacioncomentario: string;
    estado: string;
    ultimousuario: string;
    reprogramacionpuntollegada: string;
    reprogramacionpuntopartida: string;
    reprogramacionmotivo: string;
    documentosindespachoflag: string;
    numerocontrato: string;
    letraflag: string;
    concepto: string;
    ingresoweb: string;
    letraestado: string;
    letratiponegociacion: string;
    letranumerounico: string;
    letraplanillabanco: string;
    letrapresentadavoucher: string;
    documentosincantidadflag: string;
    establecimientocodigo: string;
    formafacturacion: string;
    clienteruc: string;
    clientenombre: string;
    clientedireccion: string;
    clientereferencia: string;
    clientecontacto: string;
    tipofacturacion: string;
    tipoventa: string;
    conceptofacturacion: string;
    formadepago: string;
    monedadocumento: string;
    criteria: string;
    percepciondocumento: string;
    numerodocorigencanje: string;
    letranumeroseguimiento: string;
    prioridad: string;
    feestado: string;
    fehashcode: string;
    fenotacreditomotivo: string;
    fenotacreditosustento: string;
    estadosunat: string;
    observacionfe: string;
    estadoenviadotci: string;
    decripcionestadosunat: string;
    motivocomunicado: string;
    notacreditorelacionadas: string;
    tipodespacho: string;
    clientedirecciondespacho: string;
    descuento04flag: string;
    vobo4todctoflag: string;
    vobocomercialflag: string;


    coDocumentodetalle: any[];
    coDocumentodetallecomentario: any[];
    coDocumentodescuentos: any[];
    coDocumentoimpuesto: any[];
    syDocumentoanexos: any[];

    iv_AutomaticoPedido: boolean;
    iv_tc_comercial: boolean;

    idc_Bonificacion: number;
    sumatoriaTotal: number;
    margenVenta: number;
    sumatoriaCostoTotal: number;
    item: string;
    cantidad: number;
    iv_action: string;
    tipoVendedor: string;

    linea: number;
    descuento01: number;
    descuento02: number;
    descuento03: number;
    descuento04: number;
    cantidadItem: number;
    claveAutorizacion: number;

    auxFechaDocumento: string;

    montoTotalDetalle: number;
    montoMargenDetalle: number;

}
